
import { ChangeDetectionStrategy, Component, input, InputSignal, model, ModelSignal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { IconComponent } from '@libs/components/icons';
import { NavModel } from '@libs/shared/models';

@Component({
  selector: 'ui-account-navigation',
  templateUrl: './account-navigation.component.html',
  styleUrls: ['./account-navigation.component.scss'],
  imports: [
    MatCardModule,
    RouterLink,
    MatButtonModule,
    MatRippleModule,
    IconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountNavigationComponent {
  public readonly nav: InputSignal<NavModel> = input.required<NavModel>();
  public readonly currentUrl: ModelSignal<string | undefined> = model<string>();
  public readonly mobileExpanded: ModelSignal<boolean> = model<boolean>(true);
}
